import { useState } from "react";
import {
  ApartmentOutlined,
  LogoutOutlined,
  MailOutlined,
  UploadOutlined,
  UserOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";
import { Layout, Menu, theme, Typography, Drawer } from "antd";
import HeaderComponent from "../components/LayoutComponents/Header";
import {
  Link,
  Navigate,
  Route,
  Routes as Switch,
  useLocation,
} from "react-router-dom";
import Resources from "../components/Pages/Resources";
import Rotas from "../components/Pages/Rotas";
import { useUser } from "../contexts/UserContext";
import SendNotifications from "../components/Pages/SendNotifications";
import RotasView from "../components/Pages/RotasView";
import RotasTableView from "../components/Pages/RotasTableView";
import SiteLogo from "../components/LayoutComponents/SiteLogo";
import Departments from "../components/Pages/Departments";
import DepartmentTableView from "../components/Pages/DepartmentTableView";
import DepartmentsView from "../components/Pages/DepartemntsView";
import NewsLetter from "../components/Pages/NewsLetter";
import SendNewsletter from "../components/Pages/SendNewsletter";
const { Sider, Content } = Layout;
const { Text } = Typography;

const DefaultLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [responsive, setResponsive] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false); // State to control off-canvas menu visibility
  const { logout } = useUser();
  const location = useLocation();

  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  const routes = [
    {
      redirectRoute: true,
      path: "/",
      element: <Navigate to="/resources" />,
    },
    {
      redirectRoute: false,
      path: "/resources",
      element: <Resources />,
      meta: {
        title: "Resources",
        requiresAuth: false,
        menuKey: "1",
        icon: <UserOutlined />,
      },
    },
    {
      redirectRoute: false,
      path: "/rotas",
      element: <Rotas />,
      meta: {
        title: "Rotas",
        requiresAuth: false,
        menuKey: "2",
        icon: <VideoCameraOutlined />,
      },
      children: [
        { redirectRoute: false, path: ":id", element: <RotasTableView /> },
        { redirectRoute: false, path: "", element: <RotasView /> },
      ],
    },
    {
      redirectRoute: false,
      path: "/department",
      element: <Departments />,
      meta: {
        title: "Departments",
        requiresAuth: false,
        menuKey: "3",
        icon: <ApartmentOutlined />,
      },
      children: [
        { redirectRoute: false, path: "", element: <DepartmentsView /> },
        { redirectRoute: false, path: ":id", element: <DepartmentTableView /> },
      ],
    },
    {
      redirectRoute: false,
      path: "/newsletter",
      element: <NewsLetter />,
      meta: {
        title: "Newsletter",
        requiresAuth: false,
        menuKey: "4",
        icon: <MailOutlined />,
      },
    },
    {
      redirectRoute: false,
      path: "/newsletter/send",
      element: <SendNewsletter />,
    },

    { redirectRoute: true, path: "*", element: <Navigate to="/resources" /> },
    {
      redirectRoute: false,
      path: "/send-notifications",
      element: <SendNotifications />,
      meta: {
        title: "Send Notification",
        requiresAuth: false,
        menuKey: "5",
        icon: <UploadOutlined />,
      },
    },
    { redirectRoute: true, path: "*", element: <Navigate to="/resources" /> },
  ];

  const getActiveSidebarItem = () => {
    const key = routes.find((route) => location.pathname === route.path)?.meta
      ?.menuKey;
    return key;
  };

  return (
    <Layout className="antLayoutHeight">
      {/* Sidebar */}
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width="260"
        style={{
          borderRight: "1px solid #EFF2F7",
          height: "100vh",
          position: "fixed",
        }}
        breakpoint="md"
        onBreakpoint={(broken) => {
          if (broken) {
            setCollapsed(true);
            setResponsive(true);
          } else {
            setResponsive(false);
            setCollapsed(false);
          }
        }}
      >
        <div className="logo">
          <Link to="/resources">
            <SiteLogo collapsed={collapsed} />
          </Link>
          <Text style={{ padding: "20px" }} type="secondary">
            Menu
          </Text>
        </div>

        <div className="demo-logo-vertical" />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "calc(95vh - 100px)",
          }}
        >
          <Menu
            mode="inline"
            defaultSelectedKeys={["1"]}
            onSelect={() => closeDrawer()}
            selectedKeys={[getActiveSidebarItem()]}
          >
            {routes.map(
              (route) =>
                !route.redirectRoute &&
                route.meta && (
                  <Menu.Item
                    key={route.meta.menuKey}
                    icon={route?.meta?.icon}
                    onSelectCapture={closeDrawer}
                  >
                    <Link to={route.path}>{route.meta?.title}</Link>
                  </Menu.Item>
                )
            )}
          </Menu>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <Menu mode="inline">
              <Menu.Item
                icon={<LogoutOutlined />}
                onClick={() => logout(true)}
                style={{ color: "#DD1F28" }}
              >
                Logout
              </Menu.Item>
            </Menu>
          </div>
        </div>
      </Sider>
      {/* Off-canvas Drawer for Mobile */}
      <Drawer
        title={<SiteLogo />}
        placement="left"
        closable={false}
        onClose={closeDrawer}
        open={drawerVisible}
        width={260}
        styles={{
          body: {
            padding: "16px",
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column",
          },
        }}
      >
        <Menu
          mode="inline"
          defaultSelectedKeys={["1"]}
          selectedKeys={[getActiveSidebarItem()]}
          onSelect={() => closeDrawer()}
        >
          {routes.map(
            (route) =>
              !route.redirectRoute &&
              route.meta && (
                <Menu.Item key={route.meta.menuKey} icon={route?.meta?.icon}>
                  <Link to={route.path}>{route.meta.title}</Link>
                </Menu.Item>
              )
          )}
        </Menu>
        <Menu mode="inline">
          <Menu.Item
            icon={<LogoutOutlined />}
            onClick={() => logout(true)}
            style={{ color: "#DD1F28" }}
          >
            Logout
          </Menu.Item>
        </Menu>
      </Drawer>
      <Layout
        style={{
          marginInlineStart: collapsed ? 80 : 260,
          transition: "margin ease-in 0.2s",
        }}
      >
        <HeaderComponent
          toggleCollapsed={toggleCollapsed}
          collapsed={collapsed}
          responsive={responsive}
          showDrawer={showDrawer} // Pass showDrawer to Header
        />
        <Content
          style={{
            margin: "22px 32px",
            padding: 0,
            minHeight: 280,
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
            overflowY: "auto",
            overflowX: "hidden",
            position: "relative",
          }}
        >
          <Switch>
            {routes.map((item, index) => (
              <Route key={index} path={item.path} element={item.element}>
                {item.children?.map((child, children_index) => (
                  <Route
                    key={children_index + child.path}
                    path={child.path}
                    element={child.element}
                  />
                ))}
              </Route>
            ))}
          </Switch>
        </Content>
      </Layout>
    </Layout>
  );
};

export default DefaultLayout;
